import { Stack } from "@mui/system";
import { Box, Container, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Certificate1 from "@/app/assets/images/our-certificates/Certificate-1.jpg";
import Certificate2 from "@/app/assets/images/our-certificates/Certificate-2.jpg";

const OurCertificates = () => {
  const { t } = useTranslation("landing");

  return (
    <section id="certificates">
      <Container
        maxWidth={"xl"}
        sx={{
          height: "100%",
        }}
      >
        <Stack direction="column" alignItems="center">
          <Typography
            variant="h2"
            sx={{
              fontWeight: 600,
              fontSize: "34px",
              color: "#0B1370",
              marginBottom: "40px",
              textAlign: "center",
            }}
          >
            {t("our_certificates")}
          </Typography>

          <Grid container spacing={8} justifyContent="center" mb={20}>
            <Grid item xs={12} md={6}>
              <Box>
                <Box
                  component="a"
                  href={Certificate1}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <Box
                    component="img"
                    src={Certificate1}
                    alt="First Certificate"
                    style={{
                      width: "100%",
                      borderTopRightRadius: "10px",
                      borderTopLeftRadius: "10px",
                      marginBottom: "-10px",
                    }}
                  />
                </Box>
                <Typography
                  sx={{
                    textAlign: "center",
                    fontSize: { xs: "18px", sm: "21px", md: "26px" },
                    fontWeight: 600,
                    color: "#0B1370",
                    background: "#E6F1FF",
                    padding: "24px 32px",
                    borderBottomRightRadius: "10px",
                    borderBottomLeftRadius: "10px",
                  }}
                >
                  {t("certificates.first")}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box>
                <Box
                  component="a"
                  href={Certificate2}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <Box
                    component="img"
                    src={Certificate2}
                    alt="Second Certificate"
                    style={{
                      width: "100%",
                      borderTopRightRadius: "10px",
                      borderTopLeftRadius: "10px",
                      marginBottom: "-10px",
                    }}
                  />
                </Box>
                <Typography
                  sx={{
                    textAlign: "center",
                    fontSize: { xs: "18px", sm: "21px", md: "26px" },
                    fontWeight: 600,
                    color: "#0B1370",
                    background: "#E6F1FF",
                    padding: "24px 32px",
                    borderBottomRightRadius: "10px",
                    borderBottomLeftRadius: "10px",
                  }}
                >
                  {t("certificates.second")}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Stack>
      </Container>
    </section>
  );
};

export default OurCertificates;
